import { REFINE_MODES, getRefineInstruction } from '@promptcrew/authoring';
import {
  SearchOutlined as SearchIcon,
  MenuBookOutlined as MenuBookIcon,
  HandymanOutlined as BuildIcon,
  ChatBubbleOutline as ChatIcon,
  AutoFixHighOutlined as RefineIcon,
} from '@mui/icons-material';

const FIND_MISSING_INSTRUCTION = getRefineInstruction('missing');

export const REFINE_HELP_OPTIONS = [
  ['standardize-promptcrew', 'standardize'],
  ['assess-missing', 'missing'],
  ['reuse-refine', 'reuse'],
  ['tighten-refine', 'output'],
].map(([id, mode]) => ({ id, label: REFINE_MODES[mode].label, instruction: getRefineInstruction(mode) }));

export function buildFindMissingRefineOption(capabilityType = 'prompt') {
  const type = ['prompt', 'skill', 'agent'].includes(capabilityType) ? capabilityType : 'prompt';
  return { id: `find-missing-${type}`, label: REFINE_MODES.missing.label, instruction: FIND_MISSING_INSTRUCTION };
}

export function buildStandardizePromptCrewRefineOption(capabilityType = 'prompt') {
  const type = ['prompt', 'skill', 'agent'].includes(capabilityType) ? capabilityType : 'prompt';
  return { id: `standardize-promptcrew-${type}`, label: REFINE_MODES.standardize.label, instruction: getRefineInstruction('standardize', type) };
}

export const ASSISTANT_INTENT_CHIPS = [
  {
    id: 'find',
    label: 'Find a capability',
    preflightMode: 'capabilities',
    icon: SearchIcon,
    customPlaceholder: 'I want to find a capability that...',
    suggestions: [
      'Find an email follow-up capability.',
      'Find a campaign planning capability.',
      'Find a product requirements capability.',
      'Find a dataset summary capability.',
    ],
  },
  {
    id: 'search',
    label: 'Search Knowledge',
    preflightMode: 'contexts',
    icon: MenuBookIcon,
    customPlaceholder: 'I want to find knowledge about...',
    suggestions: [
      'Find examples of strong email follow-up.',
      'Search for campaign planning reference material.',
      'Find product requirement templates.',
      'Search for dataset definitions and reporting notes.',
    ],
  },
  {
    id: 'build',
    label: 'Build a capability',
    action: 'build',
    icon: BuildIcon,
    customPlaceholder: 'I want to build...',
    suggestions: [
      'Build an email follow-up capability.',
      'Create a campaign planning workflow.',
      'Build a product requirements capability.',
      'Build a dataset summary assistant.',
    ],
  },
  {
    id: 'refine',
    label: 'Refine',
    action: 'refine',
    icon: RefineIcon,
    customPlaceholder: 'Paste text to refine or describe how to improve it...',
    suggestions: REFINE_HELP_OPTIONS.map((opt) => opt.label),
    refineOptions: REFINE_HELP_OPTIONS,
  },
  {
    id: 'chat',
    label: 'Chat',
    skipPreflight: true,
    icon: ChatIcon,
    customPlaceholder: 'I want to chat about...',
    suggestions: [
      'Help me think through this request.',
      'Turn this rough idea into a clearer plan.',
      'Help me decide whether to find, build, or refine a capability.',
      'Summarize what I should do next.',
    ],
  },
];

export function resolveRefineInstruction(text, chipConfig) {
  const trimmed = String(text || '').trim();
  const match = (chipConfig?.refineOptions || REFINE_HELP_OPTIONS).find((opt) => opt.label === trimmed);
  if (match) return { instruction: match.instruction, userLabel: match.label };
  return { instruction: trimmed, userLabel: trimmed };
}
